import {
  Question,
  QuizModule,
  // quizModules
} from "@common";
import { TestTakerSettings } from "@natklok/contexts/testTakerSettingsContext";

const getTotalAmountQuestions = ({
  settings,
  questions,
  quizModules,
}: {
  settings: TestTakerSettings;
  questions: Question[];
  quizModules: Record<string, QuizModule>;
}) => {
  const nonDuplicatedQuestions: any[] = [];

  const quizModuleValues = Object.values(quizModules) as QuizModule[];
  for (let i = 0; i < quizModuleValues.length; i++) {
    const quizModule = quizModuleValues[i];

    for (let j = 0; j < quizModule.slides.length; j++) {
      const questionVariant = quizModule.slides[j];

      for (let k = 0; k < questions.length; k++) {
        if (
          questions[k].variant.sv === questionVariant &&
          questions[k].fitsAges.includes(settings.age) &&
          nonDuplicatedQuestions.includes(questions[k]) === false
        ) {
          nonDuplicatedQuestions.push(questions[k]);
          break;
        }
      }
    }
  }

  return nonDuplicatedQuestions.length;
};

export default getTotalAmountQuestions;
